<div *ngIf="dataset">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-listbox [multiple]="multiple">
    <ng-content></ng-content>
    <ng-container *ngIf="selectedItems$ | async as selectedItems">
      <mat-chip-option
        *ngFor="let item of selectedItems"
        [value]="item"
        [selected]="true"
        [selectable]="true"
        (click)="toggleItem(item)"
        [title]="dataset.getLabel(item)"
      >
        <span class="chip-label">{{ dataset.getLabel(item) }}</span>
        <mat-icon>clear</mat-icon>
      </mat-chip-option>
    </ng-container>
  </mat-chip-listbox>
  <mat-form-field appearance="fill">
    <mat-select #matSelect>
      <mat-option *ngFor="let item of unselectedItems" [value]="dataset.getValue(item)" (onSelectionChange)="select($event, item)">
        {{ dataset.getLabel(item) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
